import { Arrears } from 'Feature/Arrears/components/ArrearsInquiryPage/core/Arrears';

export interface ApiArrearsUpdateCommand {
  status: string;
  amount: number;
  dueDate: string;
  institutionNumber: string;
  transitNumber: string;
}

export const toApiArrearsUpdateCommand = (arrears: Arrears): ApiArrearsUpdateCommand => ({
  status: arrears.status,
  dueDate: arrears.dueDate,
  amount: arrears.amount,
  institutionNumber: arrears.lenderInstitutionNumber,
  transitNumber: arrears.lenderTransitNumber
});
